import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';

import HitCard from 'Components/Card/HitCard/HitCard';

export default function ProductsMegaMenuTab({
  hits,
  linkTo,
  section,
  setMegaMenuTab,
  showProductLinks,
  productLinksCount,
  subText,
  tab,
  title,
  viewedHook,
  children,
}) {
  const [hasRunViewedHook, setHasRunViewedHook] = useState(false);

  useEffect(() => {
    if (tab === section && viewedHook && !hasRunViewedHook) {
      viewedHook();
      setHasRunViewedHook(true);
    }
  }, [viewedHook, tab, section, hasRunViewedHook]);


  const isFantasyVerseSection = ['fantasyVerseComicBookDay', 'fantasyVerseComicsAndGraphicNovels', 'fantasyVerseManga', 'fantasyVerseTableTopRPG', 'fantasyVerseTopSellers'].includes(section);
  if (isEmpty(hits)) return false;
  return (
    <div className={classNames(`ProductsMegaMenu__tab ProductsMegaMenu__tab--${section}`, { 'ProductsMegaMenu__tab--visible': tab === section })}>
      {section === 'xbox' ?
        <div className="ProductsMegaMenu__tabLogo ProductsMegaMenu__tabLogo--xbox">
          <img src="https://cdn.fanatical.com/production/brand/about-us/publishers/xbox.svg" alt="Xbox" />
        </div>
        :
        <div className="ProductsMegaMenu__tabTitle">
          {title}
        </div>
      }
      <div className="ProductsMegaMenu__tabText">
        {subText}
      </div>
      <div className="row ProductsMegaMenu__tabGrid">
        {hits.slice(0, 3).map(hit =>
          <HitCard
            hitCardLightTheme
            place="Mega Menu"
            key={hit.objectID}
            hit={hit}
            xsSize={6}
            lgSize={4}
            clickFunction={() => setMegaMenuTab('')}
          />,
        )}
      </div>
      {showProductLinks &&
        <div className="ProductsMegaMenu__tabProductLinks">
          <FormattedMessage
            id="products-megamenu-tab.product-links.plus"
            defaultMessage="Plus: "
          />
          <ul>
            {hits.slice(3, 3 + productLinksCount).map(hit =>
              <li key={hit.objectID}>
                <Link to={`/${hit.type}/${hit.slug}`} onClick={() => setMegaMenuTab('')}>
                  {hit.name}
                </Link>
              </li>,
            )}
          </ul>
          {!!linkTo &&
            <Link to={linkTo} onClick={() => setMegaMenuTab('')}>
              <FormattedMessage
                id="products-megamenu-tab.product-links.more"
                defaultMessage="and more"
              />
            </Link>
          }
        </div>
      }
      {!!children &&
        <>
          {children}
        </>
      }
      {!!linkTo &&
        <Link to={linkTo} className="ProductsMegaMenu__tabButton" onClick={() => setMegaMenuTab('')}>
          {section !== 'allbundles' && section !== 'gaminggiftguide' && section !== 'gamedeals' && !isFantasyVerseSection &&
            <React.Fragment>
              <FormattedMessage
                id="products-megamenu-tab.button.all"
                defaultMessage="Browse all"
              />&nbsp;
              {title}
            </React.Fragment>
          }
          {isFantasyVerseSection &&
            <FormattedMessage
              id="products-megamenu-tab.button.browseonfantasyverse"
              defaultMessage="Browse all products on FantasyVerse"
            />
          }
          {section === 'allbundles' &&
            <FormattedMessage
              id="products-megamenu-tab.button.allbundles"
              defaultMessage="Browse all bundles"
            />
          }
          {section === 'gaminggiftguide' &&
            <FormattedMessage
              id="products-megamenu-tab.button.viewgaminggiftguide"
              defaultMessage="View Gaming Gift Guide"
            />
          }
          {section === 'gamedeals' &&
            <FormattedMessage
              id="products-megamenu-tab.button.browseallgamedeals"
              defaultMessage="Browse All Game Deals"
            />
          }
        </Link>
      }
    </div>
  );
}

ProductsMegaMenuTab.propTypes = {
  hits: PropTypes.arrayOf(PropTypes.object),
  linkTo: PropTypes.string,
  section: PropTypes.string,
  setMegaMenuTab: PropTypes.func,
  showProductLinks: PropTypes.bool,
  subText: PropTypes.string,
  tab: PropTypes.string,
  title: PropTypes.string,
  productLinksCount: PropTypes.number,
};

ProductsMegaMenuTab.defaultProps = {
  hits: [],
  linkTo: '',
  section: '',
  setMegaMenuTab: () => { },
  showProductLinks: false,
  subText: '',
  tab: '',
  title: '',
  productLinksCount: 4,
};
